import { createFileRoute } from '@tanstack/react-router';

import { chatbotListScreen, chatbotListSearch, loadChatbotListScreen, loadChatbotMessages } from '@/modules/chatbot/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/chatbot` do legado (router.tsx:747-756), só no tenant raiz.
export const Route = createFileRoute('/_app/chatbot/')({
  validateSearch: chatbotListSearch,
  staticData: { screen: chatbotListScreen },
  loader: () => loadChatbotMessages(),
  component: lazyScreen(loadChatbotListScreen, 'ChatbotListRouteScreen'),
});
